var map = {
	"./productionAnimal.jpg": 3822,
	"./productionBaby.jpg": 8646,
	"./productionBody.jpg": 346,
	"./productionCosmetic.jpg": 7243,
	"./productionFace.jpg": 1977,
	"./productionFeet.jpg": 1718,
	"./productionHair.jpg": 2698,
	"./productionHands.jpg": 9898,
	"./productionLaying.jpeg": 8977,
	"./productionMan.jpg": 9868,
	"./productionSaloon.jpg": 6982,
	"./productionSuncare.jpg": 6385,
	"./production_face2.jpg": 2276
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2937;